// Import firebase modules.
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import 'firebase/analytics'
// Import firebaseui module.
var firebaseui = require('firebaseui');

// firebase init - add your own config here
const firebaseConfig = {
    apiKey: "AIzaSyAUbqHdC2GlOY_3QUxqGcKg-x6T9PNQD_I",
    authDomain: "maxicash-app.firebaseapp.com",
    databaseURL: "https://maxicash-app.firebaseio.com",
    projectId: "maxicash-app",
    storageBucket: "maxicash-app.appspot.com",
    messagingSenderId: "94610030156",
    appId: "1:94610030156:web:b37f11a1b7fb720baa3ee9",
    measurementId: "G-X1QZF0E1GN"
}
firebase.initializeApp(firebaseConfig)

// utils
const auth = firebase.auth()
const storage = firebase.storage();
const firestore = firebase.firestore();
const analytics = firebase.analytics();

// collection references
const cardCollection = firestore.collection('stamp_cards')
const customerCollection = firestore.collection('customers')
const userCollection = firestore.collection('users')
const ipAddress = firestore.collection('access_uuids').doc('o0m90fu3KNF0CQiUgzjn')
const bearer = firestore.collection("bearer")

// sign in options
const signInWithEmail = firebase.auth.EmailAuthProvider.PROVIDER_ID

// export utils/refs
export
{
    auth,
    storage,
    firestore,
    analytics,
    firebaseui,
    cardCollection,
    customerCollection,
    userCollection,
    bearer,
    ipAddress,
    signInWithEmail
}